<template>
  <span class="info-hint">
    <b-tooltip position="is-right" class="is-info" size="is-large" multilined>
      <template #content>
        <div v-html="$t(messageKey)"></div>
      </template>
      <b-icon icon="information-outline" size="is-small" class="has-text-grey-light" />
    </b-tooltip>
  </span>
  
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoHint',
  props: {
    messageKey: {
      type: String,
      required: true
    }
  }
})
</script>

<style scoped>
.info-hint {
  display: inline-flex;
  align-items: center;

  .is-small {
    font-size: smaller;
  }
}
</style>


